export const SAVE_ATR = 'SAVE_ATR';

export const SUBMIT_ATR_REQUESTED = 'SUBMIT_ATR_REQUESTED';

export const SUBMIT_ATR_COMPLETED = 'SUBMIT_ATR_COMPLETED';

export const SUBMIT_ATR_FAILED = 'SUBMIT_ATR_FAILED';

export const RESET_ATR = 'RESET_ATR';
